module.exports = __webpack_public_path__ + "static/media/StandingTall.3d72f9be.mp3";